// extracted by mini-css-extract-plugin
export var label = "_rb-0";
export var link = "_rb-1";